var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPalmGrayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 46,
    viewBox: "0 0 30 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 46,
    fill: "url(#pattern0_2592_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2592_10",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2592_10",
    transform: "scale(0.0333333 0.0217391)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2592_10",
    width: 30,
    height: 46,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAuCAYAAAA/SqkPAAAACXBIWXMAAAsTAAALEwEAmpwYAAADAElEQVRYhe3XP4hcVRQG8N+4yWg2ZgOiFooSuxSCSiRaGI2iaVxsohYS1EIRgqYxYCCIIgoGtLDQQoJgY5hUElBixKhrE0V0AylEEARZbBSNiybsstHinsHL23ffvszMKwQ/eMy9553zfffPuee+6Q0GAzW4EZ/iSvyBz/AavqhzzrAD+7ETM/gFd+NM1fGSAsEZ7MNyEDyAObyMXo1/L97Nhe9MxO6rE20ShiN4MAiGOIh3MJXZpsJ2MLMtR+yREnmTMByTZnAusz2Ot7L+m2Eb4lzEHGsiXksYjmO2Iv6ktJw78FRFdDZiGtFGGE7iLnwe/a+lpMtFPwmfk20I11X6m6QsvA7rw3YBC1KW78Q98Qu34WdpqU/gCuzGtf6d1DJ+ivjFqnBfSo79mC4MchmH8Vw2q7O4D79K+/5ENuAq/sTreAVLvcFg0McHuLcQUMVpaUnPYgt+k7bgppbxH2N2HfbgqiAs4QJ+xHdYCpG5sN2J9/EhtsZgmnLnauzpFSrXxWIKKxcT0Carr8eLUiYv4ryUVNPx3C7t3xK+wUu4ZhzhnpRI3+MFbMPleBRfSol2GKfCth634Hn8gGfVl1esPk453sAzFdsBHI32Hfg72kdxA16N/mXSpbKlhgPlGe+uCXgbh7L+DDZn/UPhk+Pp4GolPLxpcnyEvYVB5tgbvjlqb7Q64ZulYzHEaTxkddb2rS4WK+GbH82t0t6vKXxr1l7A/bJSl2GD+iq3GDELmW1bG+GNGcFshaAtFiJ2OOCZNsLnpSV7GPMF4nymGwo+88Gxgr/aCM9LSdJ0p/az9qUNfseD69vqi7pzfCqeSaF6xND+Q6CKfM82jUIwqnAeN1X06li4WI+7EM6XenPRqwPhsTGqcH6cSt9YnQjnBWRj0asD4bExiRmXSmYnwm1L5sSFx8b/JXOUuJE4JrHUq74uuhQeG5M4Tv2iVwfC04V258Jj4z8347H3uOnfYhO+wrtZe2LCj2BXS45da/iewHtthbfjsZbCa+H3OuF/APamjjLEjRtYAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmGrayIcon);
export default __webpack_public_path__ + "static/media/palm-gray-icon.b18d51151568baf65af99d48141937de.svg";
export { ForwardRef as ReactComponent };